export default "__VITE_ASSET__69ffdbee__"